
import { immerable, produce } from "immer";
import * as messages from '@radnuc/messages';


export class IBACReading {
    [immerable] = true;

    device: string;
    sensor: string;
    //algorithm: string;
    timestamp: number;
    latitude: number | null;
    longitude: number | null;
    particleSmall: number | null;
    particleLarge: number | null;
    particleSmallBio: number | null;
    particleLargeBio: number | null;
    particleSizeFraction: number | null;
    //confidence: number | null;
    //alarm: boolean;

    constructor(
        device: string,
        //algorithm: string,
        sensor: string,
        timestamp: number,
        latitude: number | null,
        longitude: number | null,
        particleSmall: number | null,
        particleLarge: number | null,
        particleSmallBio: number | null,
        particleLargeBio: number | null,
        particleSizeFraction: number | null,
        //confidence: number | null,
        //alarm: boolean,
    ) {
        this.device = device;
        this.sensor = sensor;
        //this.algorithm = algorithm;
        this.timestamp = timestamp;
        this.latitude = latitude;
        this.longitude = longitude;
        this.particleSmall = particleSmall;
        this.particleLarge = particleLarge;
        this.particleSmallBio = particleSmallBio;
        this.particleLargeBio = particleLargeBio;
        this.particleSizeFraction = particleSizeFraction;
        //this.confidence = confidence;
        //this.alarm = alarm;
    }

    toString() {
        const str = this.device + ',' + this.timestamp + ',' + this.latitude + ',' + this.longitude + ',' + this.particleSmall +
            ',' + this.particleLarge + ',' + this.particleSmallBio + ',' + this.particleLargeBio + ',' + this.particleSizeFraction;// + ',' + this.alarm
        return str
    }
    static getPlottableDataNames(){
        return ['particleSmall','particleLarge','particleSmallBio','particleLargeBio'];
    }
    static getDefaultPlot1(){
        return 'particleLargeBio'
    }
    static getDefaultPlot2(){
        return 'particleSmallBio'
    }
    getDataFromName(name:string){
        if(name === 'particleSmall')
            return (this.particleSmall);
        else if (name === 'particleLarge')
            return (this.particleLarge);
        else if (name === 'particleSmallBio')
            return (this.particleSmallBio);
        else if (name === 'particleLargeBio')
            return (this.particleLargeBio);
        else
            return null;
    }
    getMinScaleFromName(name:string){
        if(name === 'particleSmall')
            return (10);
        else if (name === 'particleLarge')
            return (50);
        else if (name === 'particleSmallBio')
            return (10);
        else if (name === 'particleLargeBio')
            return (50);
        else
            return null;
    }
    getTitleStringFromName(name:string) {
        if(name === 'particleSmall')
            return 'Sm. Particle Count';
        else if (name === 'particleLarge')
            return 'Lg. Particle Count';
        else if (name === 'particleSmallBio')
            return 'Sm. Bio Count';
        else if (name === 'particleLargeBio')
            return 'Lg. Bio Count';
        else
            return 'Plot';
    }


    updatePosition(latitude: number, longitude: number) {
        return produce(this, draft => {
            draft.latitude = latitude;
            draft.longitude = longitude;
        })
    }

    updateCounts(particleSmall: number, particleLarge: number, particleSmallBio: number, particleLargeBio: number, particleSizeFraction: number) {
        return produce(this, draft => {
            this.particleSmall = particleSmall;
            this.particleSmallBio = particleSmallBio;
            this.particleLarge = particleLarge;
            this.particleLargeBio = particleLargeBio;
            this.particleSizeFraction = particleSizeFraction;
        })
    }
}

export enum PlottableSensorTypes {IBAC,TAC7,MET,TACBIO,ADAv3,ADAv5a,ADAv5b,CBSIGMA}

export class PlottableSensorReading {
    [immerable] = true;

    device: string;
    sensor: string;
    sensor_type: PlottableSensorTypes;
    //algorithm: string;
    timestamp: number;
    latitude: number | null;
    longitude: number | null;
    particle_count: number[] | null;
    bio_particle_count: number[] | null;
    wind_direction: number | null;
    wind_speed: number | null;
    temperature: number | null;
    confidence: number | null;
    cbSigmaOutput: CBSigmaOutput | null;

    constructor(
        device: string,
        //algorithm: string,
        sensor: string,
        sensor_type: PlottableSensorTypes,
        timestamp: number,
        latitude?: number | null,
        longitude?: number | null,
        particle_count?: number[] | null,
        bio_particle_count?: number[] | null,
        wind_direction?: number | null,
        wind_speed?: number | null,
        temperature?: number | null,
        confidence?: number | null,
        cbSigmaOutput?: CBSigmaOutput | null

    ) {
        if(latitude === undefined)
            latitude = null;
        if(longitude === undefined)
            longitude = null;
        if(particle_count === undefined)
            particle_count = null;
        if(particle_count === undefined)
            particle_count = null;
        if(bio_particle_count === undefined)
            bio_particle_count = null;
        if(wind_direction === undefined)
            wind_direction = null;
        if(wind_speed === undefined)
            wind_speed = null;
        if(temperature === undefined)
            temperature = null;
        if(confidence === undefined)
            confidence = null;
        if(cbSigmaOutput === undefined)
            cbSigmaOutput = null;

        this.device = device;
        this.sensor = sensor;
        this.sensor_type = sensor_type;
        //this.algorithm = algorithm;
        this.timestamp = timestamp;
        this.latitude = latitude;
        this.longitude = longitude;
        this.particle_count = particle_count;
        this.bio_particle_count = bio_particle_count;
        this.wind_direction = wind_direction;
        this.wind_speed = wind_speed;
        this.temperature = temperature;
        this.confidence = confidence;
        this.cbSigmaOutput = cbSigmaOutput;

    }

    toString() {
        /*
        const str = this.device + ',' + this.timestamp + ',' + this.latitude + ',' + this.longitude + ',' + this.particleSmall +
            ',' + this.particleLarge + ',' + this.particleSmallBio + ',' + this.particleLargeBio + ',' + this.particleSizeFraction;// + ',' + this.alarm
            */
        const str = '';
        return str
    }

    getCSVLabel(){
        if(this.sensor_type === PlottableSensorTypes.IBAC)
            return 'Node, Sensor, Timestamp, latitude, longitude, particleSmall, particleLarge, particleSmallBio, particleLargeBio';
        else if (this.sensor_type === PlottableSensorTypes.TAC7)
            return 'Node, Sensor, Timestamp, latitude, longitude, Count[.5-1um], Count[1-2um], Count[2-4um], Count[4-15um], BioCount[.5-1um], BioCount[1-2um], BioCount[2-4um], BioCount[4-15um]';
        else if (this.sensor_type === PlottableSensorTypes.TACBIO)
                return 'Node, Sensor, Timestamp, latitude, longitude, All Fluor. Count, Vis Fluor. Count, Mixed Fluor. Count, UV Fluor. Count, Mean Photon Count 1, Mean Photon Count 2';
        else if(this.sensor_type === PlottableSensorTypes.MET)
            return 'Node, Sensor, Timestamp, latitude, longitude, WindDirection, WindSpeed, Temperature';
        else if(this.sensor_type === PlottableSensorTypes.ADAv3)
            return 'Node, Sensor, Timestamp, latitude, longitude, confidence';
        else if(this.sensor_type === PlottableSensorTypes.ADAv5a)
            return 'Node, Sensor, Timestamp, latitude, longitude, confidence';
        else if(this.sensor_type === PlottableSensorTypes.ADAv5b)
            return 'Node, Sensor, Timestamp, latitude, longitude, confidence';
        return '';
    }

    getCSVRow(){
        let str = '';
        if(this.sensor_type === PlottableSensorTypes.IBAC){
            if(this.particle_count !== null && this.bio_particle_count !== null){
                str = this.device + ',' + this.sensor + ',' + this.timestamp + ',' + this.latitude + ',' + this.longitude + ',' +
                        this.particle_count[0] + ',' + this.particle_count[1] + ',' +
                        this.bio_particle_count[0] + ',' + this.bio_particle_count[1];
            }
        } else if (this.sensor_type === PlottableSensorTypes.TAC7){
            if(this.particle_count !== null && this.bio_particle_count !== null){
                str = this.device + ',' + this.sensor +','+ this.timestamp + ',' + this.latitude + ',' + this.longitude + ',' +
                        this.particle_count[0] + ',' + this.particle_count[1] + ',' + this.particle_count[2] + ',' + this.particle_count[3] + ',' +
                        this.bio_particle_count[0] + ',' + this.bio_particle_count[1] + ',' + this.bio_particle_count[2] + ',' + this.bio_particle_count[3];
            }
        } else if (this.sensor_type === PlottableSensorTypes.TACBIO) {
            if(this.particle_count !== null && this.bio_particle_count !== null){
                str = this.device + ',' + this.sensor +','+ this.timestamp + ',' + this.latitude + ',' + this.longitude + ',' +
                        this.particle_count[0] + ',' + this.particle_count[1] + ',' + this.particle_count[2] + ',' + this.particle_count[3] + ',' +
                        this.bio_particle_count[0] + ',' + this.bio_particle_count[1];
            }
        } else if(this.sensor_type === PlottableSensorTypes.MET) {
            if(this.wind_direction !== null && this.wind_speed !== null && this.temperature !== null){
                str = this.device + ',' + this.sensor +','+ this.timestamp + ',' + this.latitude + ',' + this.longitude + ',' +
                        this.wind_direction +','+this.wind_speed+','+this.temperature;
            }
        } else if(this.sensor_type === PlottableSensorTypes.ADAv3) {
            if(this.confidence !== null){
                str = this.device + ',' + this.sensor +','+ this.timestamp + ',' + this.latitude + ',' + this.longitude + ',' +
                        this.confidence;
            }
        } else if(this.sensor_type === PlottableSensorTypes.ADAv5a) {
            if(this.confidence !== null){
                str = this.device + ',' + this.sensor +','+ this.timestamp + ',' + this.latitude + ',' + this.longitude + ',' +
                        this.confidence;
            }
        } else if(this.sensor_type === PlottableSensorTypes.ADAv5b) {
            if(this.confidence !== null){
                str = this.device + ',' + this.sensor +','+ this.timestamp + ',' + this.latitude + ',' + this.longitude + ',' +
                        this.confidence;
            }
        }
        return str;
    }

    static getPlottableDataNames(sensor_type:PlottableSensorTypes){
        if(sensor_type === PlottableSensorTypes.IBAC)
            return ['particleSmall','particleLarge','particleSmallBio','particleLargeBio'];
        else if (sensor_type === PlottableSensorTypes.TAC7)
            return ['Count[.5-1um]','Count[1-2um]','Count[2-4um]','Count[4-15um]','BioCount[.5-1um]','BioCount[1-2um]','BioCount[2-4um]','BioCount[4-15um]'];
        else if (sensor_type === PlottableSensorTypes.TACBIO)
                return ['All Fluor. Count','Vis Fluor. Count','Mixed Fluor. Count','UV Fluor. Count','Mean Photon Count 1','Mean Photon Count 2'];
        else if(sensor_type === PlottableSensorTypes.MET)
            return ['WindDirection','WindSpeed','Temperature'];
        else if(sensor_type === PlottableSensorTypes.ADAv3)
            return ['Confidence'];
        else if(sensor_type === PlottableSensorTypes.ADAv5a)
            return ['Confidence'];
        else if(sensor_type === PlottableSensorTypes.ADAv5b)
            return ['Confidence'];
        else if(sensor_type === PlottableSensorTypes.CBSIGMA)
            return ['GLRT'];
        return [''];
    }
    static getDefaultPlot1(sensor_type:PlottableSensorTypes){
        if(sensor_type === PlottableSensorTypes.IBAC)
            return 'particleLargeBio'
        else if (sensor_type === PlottableSensorTypes.TAC7)
            return 'BioCount[.5-1um]'
        else if (sensor_type === PlottableSensorTypes.TACBIO)
            return 'Vis Fluor. Count'
        else if (sensor_type === PlottableSensorTypes.MET)
            return 'WindDirection'
        else if (sensor_type === PlottableSensorTypes.ADAv3)
            return 'Confidence'
        else if(sensor_type === PlottableSensorTypes.ADAv5a)
            return 'Confidence'
        else if(sensor_type === PlottableSensorTypes.ADAv5b)
            return 'Confidence'
        else if(sensor_type === PlottableSensorTypes.CBSIGMA)
            return 'GLRT';
        return '';
    }
    static getDefaultPlot2(sensor_type:PlottableSensorTypes){
        if(sensor_type === PlottableSensorTypes.IBAC)
            return 'particleSmallBio'
        else if (sensor_type === PlottableSensorTypes.TAC7)
            return 'BioCount[1-2um]'
        else if (sensor_type === PlottableSensorTypes.TACBIO)
            return 'UV Fluor. Count'
        else if (sensor_type === PlottableSensorTypes.MET)
            return 'WindSpeed'
        else if (sensor_type === PlottableSensorTypes.ADAv3)
            return ''
        else if (sensor_type === PlottableSensorTypes.ADAv5a)
            return ''
        else if (sensor_type === PlottableSensorTypes.ADAv5b)
            return ''
        else if(sensor_type === PlottableSensorTypes.CBSIGMA)
            return '';
        return '';
    }
    getDataFromName(name:string){
        if(this.sensor_type === PlottableSensorTypes.IBAC){
            if(name === 'particleSmall' && this.particle_count !== null)
                return (this.particle_count[0]);
            else if (name === 'particleLarge' && this.particle_count !== null)
                return (this.particle_count[1]);
            else if (name === 'particleSmallBio' && this.bio_particle_count !== null)
                return (this.bio_particle_count[0]);
            else if (name === 'particleLargeBio' && this.bio_particle_count !== null)
                return (this.bio_particle_count[1]);
        } else if(this.sensor_type === PlottableSensorTypes.TAC7){
            if(name === 'Count[.5-1um]' && this.particle_count !== null)
                return (this.particle_count[0]);
            else if (name === 'Count[1-2um]' && this.particle_count !== null)
                return (this.particle_count[1]);
            else if(name === 'Count[2-4um]' && this.particle_count !== null)
                return (this.particle_count[2]);
            else if (name === 'Count[4-15um]' && this.particle_count !== null)
                return (this.particle_count[3]);
            else if (name === 'BioCount[.5-1um]' && this.bio_particle_count !== null)
                return (this.bio_particle_count[0]);
            else if (name === 'BioCount[1-2um]' && this.bio_particle_count !== null)
                return (this.bio_particle_count[1]);
            else if (name === 'BioCount[2-4um]' && this.bio_particle_count !== null)
                return (this.bio_particle_count[2]);
            else if (name === 'BioCount[4-15um]' && this.bio_particle_count !== null)
                return (this.bio_particle_count[3]);
        } else if(this.sensor_type === PlottableSensorTypes.TACBIO){
            if(name === 'All Fluor. Count' && this.particle_count !== null)
                return (this.particle_count[0]);
            else if (name === 'Vis Fluor. Count' && this.particle_count !== null)
                return (this.particle_count[1]);
            else if(name === 'Mixed Fluor. Count' && this.particle_count !== null)
                return (this.particle_count[2]);
            else if (name === 'UV Fluor. Count' && this.particle_count !== null)
                return (this.particle_count[3]);
            else if (name === 'Mean Photon Count 1' && this.bio_particle_count !== null)
                return (this.bio_particle_count[0]);
            else if (name === 'Mean Photon Count 2' && this.bio_particle_count !== null)
                return (this.bio_particle_count[1]);
        } else if(this.sensor_type === PlottableSensorTypes.MET){
            if(name === 'WindDirection' && this.wind_direction !== null)
                return (this.wind_direction);
            if(name === 'WindSpeed' && this.wind_speed !== null)
                return (this.wind_speed);
            if(name === 'Temperature' && this.temperature !== null)
                return (this.temperature);
        } else if(this.sensor_type === PlottableSensorTypes.ADAv3){
            if(name === 'Confidence' && this.confidence !== null)
                return (this.confidence);
        } else if(this.sensor_type === PlottableSensorTypes.ADAv5a){
            if(name === 'Confidence' && this.confidence !== null)
                return (this.confidence);
        } else if(this.sensor_type === PlottableSensorTypes.ADAv5b){
            if(name === 'Confidence' && this.confidence !== null)
                return (this.confidence);
        } else if(this.sensor_type === PlottableSensorTypes.CBSIGMA){
            if(name === 'GLRT' && this.cbSigmaOutput !== null){
                if(this.cbSigmaOutput.algorithmState !== 1 && this.cbSigmaOutput.algorithmState !== 12){
                    return (this.cbSigmaOutput.detectionSignif);
                } else {
                    return null;
                }
            }
        } else
            return null;
    }
    getMinScaleFromName(name:string){
        if(this.sensor_type === PlottableSensorTypes.IBAC){
            if(name === 'particleSmall')
                return (10);
            else if (name === 'particleLarge')
                return (50);
            else if (name === 'particleSmallBio')
                return (10);
            else if (name === 'particleLargeBio')
                return (50);
        } else if(this.sensor_type === PlottableSensorTypes.TAC7){
            if(name === 'Count[.5-1um]')
                return (50);
            else if (name === 'Count[1-2um]')
                return (50);
            else if (name === 'Count[2-4um]')
                return (50);
            else if (name === 'BioCount[4-15um]')
                return (50);
            else if (name === 'BioCount[.5-1um]')
                return (50);
            else if (name === 'BioCount[1-2um]')
                return (50);
            else if (name === 'BioCount[2-4um]')
                return (50);
            else if (name === 'BioCount[4-15um]')
                return (50);
        } else if(this.sensor_type === PlottableSensorTypes.TACBIO){
            if(name === 'All Fluor. Count')
                return (10);
            else if (name === 'Vis Fluor. Count')
                return (10);
            else if (name === 'Mixed Fluor. Count')
                return (10);
            else if (name === 'UV Fluor. Count')
                return (10);
            else if (name === 'Mean Photon Count 1')
                return (10);
            else if (name === 'Mean Photon Count 2')
                return (10);
        } else if(this.sensor_type === PlottableSensorTypes.MET){
            if(name === 'WindSpeed')
                return (2);
            else if (name === 'WindDirection')
                return (360);
            else if (name === 'Temperature')
                return (20);
        } else if(this.sensor_type === PlottableSensorTypes.ADAv3){
            if(name === 'Confidence')
                return (-99999);
        } else if(this.sensor_type === PlottableSensorTypes.ADAv5a){
            if(name === 'Confidence')
                return (-99999);
        } else if(this.sensor_type === PlottableSensorTypes.ADAv5b){
            if(name === 'Confidence')
                return (-99999);
        } else if(this.sensor_type === PlottableSensorTypes.CBSIGMA){
            if(name === 'GLRT')
                return (-99999);
        }

        return null;
    }
    getLabelDecimalPlace(name:string){
        if(this.sensor_type === PlottableSensorTypes.TACBIO){
           if(name === 'Mean Photon Count 1')
               return (1);
           else if (name === 'Mean Photon Count 2')
               return (1);
           else
               return (0);
        }
        if(this.sensor_type === PlottableSensorTypes.MET){
           if(name === 'WindSpeed')
               return (1);
           else if (name === 'WindDirection')
               return (0);
           else if (name === 'Temperature')
               return (1);
        }
        if(this.sensor_type === PlottableSensorTypes.ADAv3){
           if(name === 'Confidence')
               return (3);
        }
        if(this.sensor_type === PlottableSensorTypes.ADAv5a){
           if(name === 'Confidence')
               return (3);
        }
        if(this.sensor_type === PlottableSensorTypes.ADAv5b){
           if(name === 'Confidence')
               return (3);
        }
        if(this.sensor_type === PlottableSensorTypes.CBSIGMA){
           if(name === 'GLRT')
               return (2);
        }
        return(0);
    }
    getYAxisFloor(name:string){
        if(this.sensor_type === PlottableSensorTypes.MET){
           if(name === 'WindSpeed')
               return null;
           else if (name === 'WindDirection')
               return (0);
           else if (name === 'Temperature')
               return null;
        }
        if(this.sensor_type === PlottableSensorTypes.ADAv3){
           if(name === 'Confidence')
               return (0);
        }
        if(this.sensor_type === PlottableSensorTypes.ADAv5a){
           if(name === 'Confidence')
               return (0);
        }
        if(this.sensor_type === PlottableSensorTypes.ADAv5b){
           if(name === 'Confidence')
               return (0);
        }
        if(this.sensor_type === PlottableSensorTypes.CBSIGMA){
           if(name === 'GLRT')
               return (0);
        }
        return null;
    }
    getTitleStringFromName(name:string) {
        if(this.sensor_type === PlottableSensorTypes.IBAC){
            if(name === 'particleSmall')
                return 'Sm. Particle Count';
            else if (name === 'particleLarge')
                return 'Lg. Particle Count';
            else if (name === 'particleSmallBio')
                return 'Sm. Bio Count';
            else if (name === 'particleLargeBio')
                return 'Lg. Bio Count';
        } else if(this.sensor_type === PlottableSensorTypes.TAC7){
            if(name === 'Count[.5-1um]')
                return 'Count [.5-1um]';
            else if (name === 'Count[1-2um]')
                return 'Count [1-2um]';
            else if (name === 'Count[2-4um]')
                return 'Count [2-4um]';
            else if (name === 'Count[4-15um]')
                return 'Count [4-15um]';
            else if (name === 'BioCount[.5-1um]')
                return 'Bio Count [.5-1um]';
            else if (name === 'BioCount[1-2um]')
                return 'Bio Count [1-2um]';
            else if (name === 'BioCount[2-4um]')
                return 'Bio Count [2-4um]';
            else if (name === 'BioCount[4-15um]')
                return 'Bio Count [4-15um]';
        } else if(this.sensor_type === PlottableSensorTypes.TACBIO){
            if(name === 'All Fluor. Count')
                return 'All Fluor. Count';
            else if (name === 'Vis Fluor. Count')
                return 'Vis. Fluor. Count';
            else if (name === 'Mixed Fluor. Count')
                return 'Mixed Fluor. Count';
            else if (name === 'UV Fluor. Count')
                return 'UV Fluor. Count';
            else if (name === 'Mean Photon Count 1')
                return 'Mean Photon Count 1';
            else if (name === 'Mean Photon Count 2')
                return 'Mean Photon Count 2';
        } else if(this.sensor_type === PlottableSensorTypes.MET){
            if(name === 'WindDirection')
                return 'Wind Dir [deg]';
            else if (name === 'WindSpeed')
                return 'Wind Speed [m/s]';
            else if (name === 'Temperature')
                return 'Temperature [degC]';
        } else if(this.sensor_type === PlottableSensorTypes.ADAv3){
            if(name === 'Confidence')
                return 'Confidence';
        } else if(this.sensor_type === PlottableSensorTypes.ADAv5a){
            if(name === 'Confidence')
                return 'Confidence';
        } else if(this.sensor_type === PlottableSensorTypes.ADAv5b){
            if(name === 'Confidence')
                return 'Confidence';
        } else if(this.sensor_type === PlottableSensorTypes.CBSIGMA){
            if(name === 'GLRT')
                return 'GLRT';
        }
        return 'Plot';
    }


    updatePosition(latitude: number, longitude: number) {
        return produce(this, draft => {
            draft.latitude = latitude;
            draft.longitude = longitude;
        })
    }

    updateCounts(particle_count: number[], bio_particle_count: number[]) {
        return produce(this, draft => {
            this.particle_count = particle_count;
            this.bio_particle_count = bio_particle_count;
        })
    }
    updateWind(wind_direction: number, wind_speed: number) {
        return produce(this, draft => {
            this.wind_direction = wind_direction;
            this.wind_speed = wind_speed;
        })
    }
    updateConfidence(confidence: number) {
        return produce(this, draft => {
            this.confidence = confidence;
        })
    }
}



export class METReading {
    device: string;
    sensor: string;
    timestamp: number;
    latitude: number | null;
    longitude: number | null;
    windAngle: number | null;
    windSpeed: number | null;
    airTemperature: number | null;

    constructor(
        device: string,
        sensor: string,
        timestamp: number,
        latitude: number | null,
        longitude: number | null,
        windAngle: number | null,
        windSpeed: number | null,
        airTemperature: number) {
        this.device = device;
        this.sensor = sensor;
        this.timestamp = timestamp;
        this.latitude = latitude;
        this.longitude = longitude;
        this.windAngle = windAngle;
        this.windSpeed = windSpeed;
        this.airTemperature = airTemperature;
    }
}

export class GPSReading {
    device: string;
    sensor: string;
    timestamp: number;
    latitude: number | null;
    longitude: number | null;
    altitude: number | null;
    heading: number | null;
    speed: number | null;
    constructor(
        device: string,
        sensor: string,
        timestamp: number,
        latitude: number | null,
        longitude: number | null,
        altitude: number | null,
        heading: number | null,
        speed: number | null) {
        this.device = device;
        this.sensor = sensor;
        this.timestamp = timestamp;
        this.latitude = latitude;
        this.longitude = longitude;
        this.altitude = altitude;
        this.heading = heading;
        this.speed = speed;
    }
}

export class AlgorithmResult {
    [immerable] = true;

    device: string;
    sensor: string;
    algorithm: string;
    timestamp: number;
    alarm: boolean;
    confidence: number | null;

    constructor(
        device: string,
        sensor: string,
        algorithm: string,
        timestamp: number,
        alarm: boolean,
        confidence: number | null
    ){
        this.device = device;
        this.sensor = sensor;
        this.algorithm = algorithm;
        this.timestamp = timestamp;
        this.alarm = alarm;
        this.confidence = confidence;
    }
    updateResult(timestamp: number, alarm: boolean, confidence: number|null) {
        return produce(this, draft => {
            draft.timestamp = timestamp;
            draft.alarm = alarm;
            draft.confidence = confidence;
        })
    }

}

export class CBSigmaOutput {
    device: string;
    sensor: string;
    timestamp: number;
    estimatedReleaseTimestamp: number | null;
    isDetecting: boolean;
    detectionSignif: number | null;
    agentId: string | null;
    algorithmState: number | null;
    contourLevels: messages.CBSigmaReport.ContourLevel[] | null;
    releaseLocation: messages.Rad.Location | null;

    constructor(
        device: string,
        sensor: string,
        timestamp: number,
        estimatedReleaseTimestamp: number | null,
        isDetecting: boolean,
        detectionSignif: number | null,
        agentId: string | null,
        algorithmState: number | null,
        contourLevels: messages.CBSigmaReport.ContourLevel[] | null,
        releaseLocation: messages.Rad.Location | null) {
        this.device = device;
        this.sensor = sensor;
        this.timestamp = timestamp;
        this.estimatedReleaseTimestamp = estimatedReleaseTimestamp;
        this.isDetecting = isDetecting;
        this.detectionSignif = detectionSignif;
        this.agentId = agentId;
        this.algorithmState = algorithmState;
        this.contourLevels = contourLevels;
        this.releaseLocation = releaseLocation;
    }
}

export type ParsedHeader = {
    timestamp: string,
    device_name: string,
    vendor: string,
    statusString?: string,
}

export type ParsedMessage =
    | PlottableSensorReading
    | METReading
    | GPSReading
    | AlgorithmResult
    //| CBSigmaOutput
    | messages.Encounter.Encounter;

export class Dataset {
    [immerable] = true;

    //plottableSensorReadings: IBACReading[];
    plottableSensorReadings: {[key: string]:PlottableSensorReading[]};
    metReadings: METReading[];
    positions: GPSReading[];
    algorithmResults: {[key:string]: AlgorithmResult[]};
    //cbSigmaOutput: CBSigmaOutput[];

    constructor(
        //plottableSensorReadings: IBACReading[],
        plottableSensorReadings: {[key: string]:PlottableSensorReading[]} = {},
        metReadings: METReading[],
        gpsReadings: GPSReading[],
        algorithmResults: {[key:string]: AlgorithmResult[]},
        cbSigmaOutput: CBSigmaOutput[]){

        this.plottableSensorReadings = plottableSensorReadings;
        this.metReadings = metReadings;
        this.positions = gpsReadings;
        this.algorithmResults = algorithmResults;
        //this.cbSigmaOutput = cbSigmaOutput;
    }
}

export class Device {
    [immerable] = true;

    name: string;
    time: Date = new Date();
    statusString: string = "";

    liveDataHistory = 300*1000; //sec
    maxHistorySize = 7200; //# entries

    positions: GPSReading[] = [] //{[key: string]:GPSReading[]} = {};
    //plottableSensorReadings: {[key: string]:IBACReading[]} = {};
    plottableSensorReadings: {[key: string]:PlottableSensorReading[]} = {};
    metReadings: {[key: string]:PlottableSensorReading[]} = {}; //METReading[] = [] //{[key: string]:METReading[]} = {};
    algorithmResults: {[key:string]: AlgorithmResult[]} = {};
    dataStatus: {[key: string]:string} = {};
    //cbSigmaOutput: {[key: string]:CBSigmaOutput[]} = {};

    constructor(name: string) {
        this.name = name;
    }

    lastReport() { return this.time; }

    updateStatus(statusString: string) {

        return produce(this, draft => {
            draft.time = new Date();
            draft.statusString = statusString;
        });
    }

    //Live Data Bulk Update
    bulkUpdate(messages: ParsedMessage[]): Device {
        //if (message instanceof PlottableSensorReading) {
        //this.currentPCSResult = message;
        const message = messages[0];
        return produce(this, draft => {
            messages.forEach(message => {
                if (message instanceof PlottableSensorReading) {

                    draft.time = new Date();
                    if(!draft.plottableSensorReadings[message.sensor]){
                        draft.plottableSensorReadings[message.sensor] = [];
                    }
                    if(draft.plottableSensorReadings[message.sensor])
                        draft.plottableSensorReadings[message.sensor].push(message);

                }
            });
            //Sort data (oldest first)
            const keys = Object.keys(draft.plottableSensorReadings)
            keys.forEach(key => {
                draft.plottableSensorReadings[key] = Object.values(draft.plottableSensorReadings[key]).sort(
                    (lhs, rhs) => lhs.timestamp - rhs.timestamp).filter((msg)=>msg.timestamp > draft.time.getTime()-this.liveDataHistory); //Need this to limit data
                //Remove repeat timestamp data
                draft.plottableSensorReadings[key] = draft.plottableSensorReadings[key].filter((item,pos,ary)=>{return !pos || item.timestamp !== ary[pos-1].timestamp});
            });
        });
    }

    //Live Data update
    update(message: ParsedMessage): Device {
        if (message instanceof GPSReading) {
            return produce(this, draft => {
                draft.time = new Date();
                /*
                if(!draft.positions[message.device]){
                    draft.positions[message.device] = [];
                }
                */
                if (draft.positions.length > this.maxHistorySize)
                    draft.positions.shift();
                draft.positions.push(message);
            })
        /*
        } else if (message instanceof IBACReading) {
            //this.currentPCSResult = message;
            return produce(this, draft => {
                draft.time = new Date();
                if(!draft.plottableSensorReadings[message.sensor]){
                    draft.plottableSensorReadings[message.sensor] = [];
                }
                if (draft.plottableSensorReadings[message.sensor].length > 130)
                    draft.plottableSensorReadings[message.sensor].shift();
                draft.plottableSensorReadings[message.sensor].push(message);
            })
        */
        } else if (message instanceof PlottableSensorReading) {
            //this.currentPCSResult = message;
            return produce(this, draft => {
                draft.time = new Date();
                if(!draft.plottableSensorReadings[message.sensor]){
                    draft.plottableSensorReadings[message.sensor] = [];
                }

                //Also cull with time
                if(draft.plottableSensorReadings[message.sensor])
                    draft.plottableSensorReadings[message.sensor].push(message);

                //Sort data (oldest first)
                draft.plottableSensorReadings[message.sensor] = Object.values(draft.plottableSensorReadings[message.sensor]).sort(
                    (lhs, rhs) => lhs.timestamp - rhs.timestamp).filter((msg)=>msg.timestamp > draft.time.getTime()-this.liveDataHistory);
                //Remove repeat timestamp data
                draft.plottableSensorReadings[message.sensor] = draft.plottableSensorReadings[message.sensor].filter((item,pos,ary)=>{return !pos || item.timestamp != ary[pos-1].timestamp});

                if (draft.plottableSensorReadings[message.sensor].length > this.maxHistorySize)
                    draft.plottableSensorReadings[message.sensor].shift();
            })
        /*
        } else if (message instanceof METReading) {
            return produce(this, draft => {
                draft.time = new Date();

                if(!draft.metReadings[message.device]){
                    draft.metReadings[message.device] = [];
                }

                if (draft.metReadings[message.sensor].length > this.maxHistorySize)
                    draft.metReadings[message.sensor].shift();
                draft.metReadings[message.sensor].push(message);
            })
        */
        } else if (message instanceof AlgorithmResult) {
            return produce(this, draft => {
                draft.time = new Date();
                if(draft.algorithmResults[message.algorithm] === undefined){
                    draft.algorithmResults[message.algorithm] = [];
                } else {
                    if (draft.algorithmResults[message.algorithm].length > this.maxHistorySize)
                        draft.algorithmResults[message.algorithm].shift();
                }
                draft.algorithmResults[message.algorithm].push(message);
            })
        }
        return this;
    }
};
